module.exports = __webpack_public_path__ + "img/insurance-seo-guarantee.5f5b3a33.png";